var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    viewBox: "0 0 300 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.232 122.253C162.232 123.657 161.092 124.797 159.684 124.797H30.544C29.14 124.797 28 123.657 28 122.253V99.9848C28 98.5808 29.14 97.4408 30.544 97.4408H159.684C161.092 97.4408 162.232 98.5808 162.232 99.9848V122.253Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.756 97.4408H30.544C29.14 97.4408 28 98.5808 28 99.9848V122.253C28 123.657 29.14 124.797 30.544 124.797H56.756V97.4408Z",
    fill: "#0561FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1719 106.121H92.8879V104.849H64.1719V106.121Z",
    fill: "#9AC7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9839 106.121H114.2V104.849H95.9839V106.121Z",
    fill: "#9AC7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7642 117.477H75.5002V116.205H71.7642V117.477Z",
    fill: "#9AC7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8838 109.905H92.3358V108.633H80.8838V109.905Z",
    fill: "#9AC7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8921 113.693H92.3361V112.421H85.8921V113.693Z",
    fill: "#9AC7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3398 117.477H92.3358V116.205H78.3398V117.477Z",
    fill: "#9AC7F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2002 109.905H77.8322V108.633H75.2002V109.905Z",
    fill: "#9AC7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 109.905H72.5918V108.633H64.2598V109.905Z",
    fill: "#9AC7F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 113.693H83.3478V112.421H64.2598V113.693Z",
    fill: "#9AC7F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 117.477H68.7758V116.205H64.2598V117.477Z",
    fill: "#9AC7F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3081 109.905H109.304V108.633H95.3081V109.905Z",
    fill: "#9AC7F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7598 113.693L118.02 113.661L118.016 112.389L99.7598 112.421",
    fill: "#9AC7F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8521 117.477H109.304V116.205H97.8521V117.477Z",
    fill: "#9AC7F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.44 109.905H118.016V108.633H112.44V109.905Z",
    fill: "#9AC7F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7119 113.693H97.3399V112.421H94.7119V113.693Z",
    fill: "#9AC7F7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2959 117.477H99.1759V116.205H95.2959V117.477Z",
    fill: "#9AC7F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.156 115.513C148.768 113.809 146.34 110.485 146.34 108.873C146.34 106.773 148.052 105.061 150.156 105.061C152.256 105.061 153.968 106.773 153.968 108.873C153.968 110.485 151.544 113.809 150.156 115.513ZM150.156 103.789C147.352 103.789 145.068 106.069 145.068 108.873C145.068 111.493 149.2 116.373 149.672 116.925L150.156 117.485L150.636 116.925C151.108 116.373 155.24 111.493 155.24 108.873C155.24 106.069 152.96 103.789 150.156 103.789Z",
    fill: "#9AC7F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.144 110.129C149.44 110.129 148.872 109.557 148.872 108.857C148.872 108.153 149.44 107.581 150.144 107.581C150.844 107.581 151.416 108.153 151.416 108.857C151.416 109.557 150.844 110.129 150.144 110.129ZM150.144 106.309C148.74 106.309 147.6 107.453 147.6 108.857C147.6 110.257 148.74 111.401 150.144 111.401C151.548 111.401 152.688 110.257 152.688 108.857C152.688 107.453 151.548 106.309 150.144 106.309Z",
    fill: "#9AC7F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.252 104.905C137.412 104.905 139.984 107.477 139.984 110.637C139.984 113.797 137.412 116.369 134.252 116.369C131.088 116.369 128.52 113.797 128.52 110.637C128.52 107.477 131.088 104.905 134.252 104.905ZM134.252 117.641C138.112 117.641 141.256 114.497 141.256 110.637C141.256 106.773 138.112 103.633 134.252 103.633C130.388 103.633 127.248 106.773 127.248 110.637C127.248 114.497 130.388 117.641 134.252 117.641Z",
    fill: "#9AC7F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.244 112.729L134.884 110.373V106.181H133.612V110.901L136.344 113.629L137.244 112.729Z",
    fill: "#9AC7F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.544 106.349C37.544 105.645 36.972 105.077 36.272 105.077C35.568 105.077 35 105.645 35 106.349C35 107.049 35.568 107.621 36.272 107.621C36.972 107.621 37.544 107.049 37.544 106.349Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9998 116.525H36.2718V112.709H36.9078V116.525H38.1798V109.529H39.4518V108.257H35.6358C34.9318 108.257 34.3638 108.829 34.3638 109.529V112.709H34.9998V116.525Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9922 106.349C48.9922 105.645 48.4242 105.073 47.7202 105.073C47.0202 105.073 46.4482 105.645 46.4482 106.349C46.4482 107.049 47.0202 107.621 47.7202 107.621C48.4242 107.621 48.9922 107.049 48.9922 106.349Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.356 108.257H44.54V109.529H45.812V116.525H47.084V112.709H47.72V116.525H48.992V112.709H49.628V109.529C49.628 108.825 49.06 108.257 48.356 108.257Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2681 106.349C43.2681 105.645 42.7001 105.077 41.9961 105.077C41.2921 105.077 40.7241 105.645 40.7241 106.349C40.7241 107.049 41.2921 107.621 41.9961 107.621C42.7001 107.621 43.2681 107.049 43.2681 106.349Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0879 109.529V112.073H40.7239V116.525H43.2679V112.073H43.9039V109.529C43.9039 108.829 43.3319 108.257 42.6319 108.257H41.3599C40.6599 108.257 40.0879 108.829 40.0879 109.529Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.24 178.001H230.716L223.332 106.457H216.84L226.24 178.001Z",
    fill: "#163F59"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.272 109.753L220.12 131.421L223.496 108.073L223.332 106.457H217.656L217.272 109.753Z",
    fill: "#212957"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.256 178.001H170.732L163.348 106.457H156.856L166.256 178.001Z",
    fill: "#163F59"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.288 109.753L160.136 131.421L163.516 108.073L163.348 106.457H157.672L157.288 109.753Z",
    fill: "#212957"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.1 178.001H121.624L129.012 106.457H135.504L126.1 178.001Z",
    fill: "#163F59"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.068 109.753L126.38 131.833L129.012 106.457H134.684L135.068 109.753Z",
    fill: "#212957"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.744 108.317H169.872V104.133H122.744V108.317Z",
    fill: "#387BFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.376 108.317H228.668V104.133H167.376V108.317Z",
    fill: "#7EB3FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.848 102.885L215.864 102.853L215.848 101.797H172.104V102.885L172.216 103.081C172.78 103.997 173.788 104.161 174.94 104.161H213.008C214.164 104.161 215.172 103.997 215.736 103.081L215.848 102.885Z",
    fill: "#D0DEE6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.304 103.065V103.093L205.412 103.253C205.588 103.489 205.804 103.665 206.052 103.789H212.704C213.816 103.789 214.784 103.657 215.328 102.917L215.432 102.757L215.452 102.729L215.44 102.209H205.304V103.065Z",
    fill: "#B6C2C9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.544 102.785H199.4V102.041H177.544V102.785Z",
    fill: "#B6C2C9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.064 101.757L199.392 80.2648C199.24 79.6928 198.66 79.2368 198.096 79.2368H167.404C166.84 79.2368 166.5 79.6928 166.648 80.2648L172.32 101.757H205.064Z",
    fill: "#212957"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.884 99.3207L169.228 81.6687H197.556L202.212 99.3207H173.884Z",
    fill: "#9AC7F7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.176 118.789C238.176 118.789 243.728 122.229 242.672 128.573C241.616 134.921 238.968 139.945 226.54 138.357C214.112 136.773 203.536 130.953 203.536 130.953C203.536 130.953 209.352 133.069 209.088 142.061C208.824 151.049 210.676 168.769 212.264 171.677C213.848 174.585 215.172 178.553 215.172 178.553H201.948L206.444 170.881L192.432 119.849C192.432 119.849 189.788 110.857 199.304 113.237C208.824 115.617 238.176 118.789 238.176 118.789Z",
    fill: "#212957"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.784 120.709L196.924 116.213C196.924 116.213 188.992 114.097 187.408 121.501C185.556 130.133 181.588 168.569 181.588 168.569L181.324 170.421L169.16 177.033H187.672L186.348 171.213L197.456 132.081C197.456 132.081 216.492 137.633 222.84 137.633C229.184 137.633 233.944 135.253 233.944 134.193C233.944 133.137 226.276 120.181 221.784 120.709Z",
    fill: "#3B47BC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.452 108.313C197.864 107.617 194.196 106.625 193.304 106.525C192.412 106.429 191.716 103.949 192.212 102.361C192.54 101.313 192.868 100.393 193.368 100.093C193.624 99.9368 193.924 99.9448 194.296 100.181C195.384 100.873 199.748 104.641 199.748 104.641C199.748 104.641 201.036 109.005 199.452 108.313Z",
    fill: "#F7B68B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.148 100.777L193.368 100.093L192.212 102.361L192.908 105.833L190.032 106.329C190.032 106.329 189.632 105.833 190.128 105.633C190.624 105.437 191.32 105.137 191.32 105.137C191.32 105.137 189.932 104.941 189.336 104.841C188.74 104.741 188.644 104.545 188.644 104.245C188.644 103.949 189.236 103.749 189.236 103.749C189.236 103.749 188.148 103.353 188.048 103.057C187.948 102.757 187.748 102.361 187.948 102.065C188.148 101.769 187.848 100.973 188.148 100.777Z",
    fill: "#EC9568"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.212 121.765C234.212 121.765 240.556 140.013 226.54 138.953C212.528 137.897 199.836 131.549 198.776 130.493C197.72 129.433 198.776 137.897 195.34 145.301C191.9 152.705 186.876 171.213 186.876 171.213L181.852 170.949L187.672 124.145C187.672 124.145 187.956 116.797 198.512 117.537C209.884 118.329 220.46 118.593 220.46 118.593L234.212 121.765Z",
    fill: "#3B47BC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.552 71.5328C231.552 71.5328 229.268 75.1328 226.776 75.3208C224.284 75.5088 223.04 69.6368 223.04 65.6568C223.04 61.6768 227.4 57.8888 227.816 56.75C228.232 55.6132 232.592 59.4048 232.592 62.8128C232.592 66.2248 231.552 70.5848 231.552 71.5328Z",
    fill: "#EC9568"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.352 81.9168C245.352 81.9168 249.5 86.7248 243.46 97.5008C237.42 108.277 234.696 114.229 233.88 114.277C233.064 114.325 228.824 114.345 227.752 112.529C226.676 110.717 225.76 109.133 226.136 108.197C226.512 107.257 235.524 83.2808 236.436 81.0648C238.28 76.5648 244.096 81.0768 245.352 81.9168Z",
    fill: "#9AC7F7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.668 80.9768L225.416 78.0048L236.128 77.8048C236.128 77.8048 241.68 78.5968 244.06 83.7528C244.88 85.5288 239.592 106.081 238.968 109.601C238.176 114.097 243.836 120.677 242.672 122.029C238.364 127.045 216.492 118.329 216.492 118.329C216.492 118.329 215.7 84.1528 219.668 80.9768Z",
    fill: "#C5E1F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.66 81.3729C220.66 81.3729 225.616 85.3409 221.648 97.0409C217.684 108.745 216.096 115.089 215.304 115.289C214.512 115.485 210.344 116.281 208.956 114.693C207.568 113.105 206.38 111.717 206.576 110.725C206.776 109.733 214.512 88.3169 215.5 86.1329C216.492 83.9529 219.272 80.7809 220.66 81.3729Z",
    fill: "#9AC7F7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.344 70.7928L234.696 79.5328C234.696 79.5328 235.028 80.7528 232.268 80.9928C228.544 81.3168 226.924 79.8568 226.924 79.8568C226.924 79.8568 229.028 75.8088 228.708 70.3048C228.384 64.8008 235.344 70.7928 235.344 70.7928Z",
    fill: "#F7B68B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.868 54.4396C228.868 54.4396 233.6 53.3044 238.26 56.8684C241.012 58.9728 242.628 62.6968 241.172 65.7728C239.716 68.8488 236.476 72.8968 234.86 72.8968C233.24 72.8968 229.676 70.4688 229.192 69.4968C228.708 68.5248 228.708 67.8768 228.384 65.7728C228.06 63.6688 226.924 64.3168 226.924 64.8008C226.924 65.2888 226.276 66.7448 225.952 65.7728C225.628 64.8008 218.992 57.8408 228.868 54.4396Z",
    fill: "#212957"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.108 54.9252C232.108 58.6808 235.26 61.7248 239.148 61.7248C243.04 61.7248 246.192 58.6808 246.192 54.9252C246.192 51.17 243.04 48.1256 239.148 48.1256C235.26 48.1256 232.108 51.17 232.108 54.9252Z",
    fill: "#212957"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 103.853C211.032 104.281 200.628 104.117 200.1 104.909C199.572 105.705 199.04 108.613 199.04 108.613C199.04 108.613 201.948 112.577 208.032 114.429C214.112 116.281 213.848 116.545 216.756 110.729C219.668 104.909 214.38 102.793 212 103.853Z",
    fill: "#9AC7F7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.912 146.345C244.96 146.345 246.612 146.105 248.06 144.845C250.14 143.033 251.044 139.809 250.74 135.269C250.536 132.201 249.328 129.101 248.052 125.813C245.9 120.281 243.464 114.017 244.736 105.729L242.372 105.365C241 114.289 243.672 121.157 245.816 126.681C247.08 129.925 248.172 132.729 248.348 135.425C248.596 139.109 247.96 141.737 246.508 143.017C245.132 144.233 243.412 143.921 243.34 143.905L242.86 146.253C242.904 146.261 243.308 146.345 243.912 146.345Z",
    fill: "#367082"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.548 165.349L223.216 168.905L242.808 175.181C242.808 175.181 244.116 173.929 239.308 171.417C233.712 168.489 225.548 165.349 225.548 165.349Z",
    fill: "#88BDDA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.068 165.349L224.4 168.905L204.808 175.181C204.808 175.181 203.5 173.929 208.308 171.417C213.904 168.489 222.068 165.349 222.068 165.349Z",
    fill: "#88BDDA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.76 169.341H225.852V154.765H221.76V169.341Z",
    fill: "#88BDDA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.808 166.097L223.812 169.493L240.584 175.481C240.584 175.481 241.704 174.289 237.592 171.889C232.796 169.093 225.808 166.097 225.808 166.097Z",
    fill: "#ACD5F4"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.808 166.097L223.8 169.493L207.028 175.481C207.028 175.481 205.912 174.289 210.024 171.889C214.816 169.093 221.808 166.097 221.808 166.097Z",
    fill: "#ACD5F4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.684 176.829C238.684 177.617 239.324 178.253 240.108 178.253C240.892 178.253 241.532 177.617 241.532 176.829C241.532 176.045 240.892 175.405 240.108 175.405C239.324 175.405 238.684 176.045 238.684 176.829Z",
    fill: "#001F46"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.188 176.829C206.188 177.617 206.828 178.253 207.612 178.253C208.396 178.253 209.032 177.617 209.032 176.829C209.032 176.045 208.396 175.405 207.612 175.405C206.828 175.405 206.188 176.045 206.188 176.829Z",
    fill: "#001F46"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.128 176.829C242.128 177.617 242.764 178.253 243.552 178.253C244.336 178.253 244.976 177.617 244.976 176.829C244.976 176.045 244.336 175.405 243.552 175.405C242.764 175.405 242.128 176.045 242.128 176.829Z",
    fill: "#367082"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.744 176.829C202.744 177.617 203.38 178.253 204.168 178.253C204.952 178.253 205.588 177.617 205.588 176.829C205.588 176.045 204.952 175.405 204.168 175.405C203.38 175.405 202.744 176.045 202.744 176.829Z",
    fill: "#367082"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.364 154.665H225.356V149.425H222.364V154.665Z",
    fill: "#367082"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.116 146.657C220.116 148.265 221.424 149.573 223.036 149.573H224.684C226.296 149.573 227.604 148.265 227.604 146.657C227.604 145.041 226.296 143.733 224.684 143.733H223.036C221.424 143.733 220.116 145.041 220.116 146.657Z",
    fill: "#367082"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.6 143.985C201.532 143.641 201.492 141.485 201.492 141.113C201.492 138.757 203.012 136.845 204.892 136.845H242.828C244.704 136.845 246.232 138.757 246.232 141.113C246.232 141.485 246.192 143.641 246.116 143.985H201.6Z",
    fill: "#8DCFFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.58 145.141C246.58 145.861 246.16 146.449 245.636 146.449H202.084C201.56 146.449 201.14 145.861 201.14 145.141C201.14 144.417 201.56 143.833 202.084 143.833H245.636C246.16 143.833 246.58 144.417 246.58 145.141Z",
    fill: "#367082"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.104 146.345C230.152 146.345 231.804 146.105 233.252 144.845C235.332 143.033 236.236 139.809 235.932 135.269C235.728 132.201 234.52 129.101 233.244 125.813C231.092 120.281 228.656 114.017 229.928 105.729L227.564 105.365C226.192 114.289 228.864 121.157 231.008 126.681C232.272 129.925 233.364 132.729 233.54 135.425C233.788 139.109 233.152 141.737 231.7 143.017C230.324 144.233 228.604 143.921 228.532 143.905L228.052 146.253C228.096 146.261 228.5 146.345 229.104 146.345Z",
    fill: "#367082"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.792 119.037C231.328 120.501 239.088 120.501 246.62 119.037C247.292 118.905 247.836 118.249 247.836 117.593C247.836 111.405 247.836 105.221 247.836 99.0368C247.836 98.3808 247.292 97.9648 246.62 98.0928C239.088 99.5608 231.328 99.5608 223.792 98.0928C223.124 97.9648 222.576 98.3808 222.576 99.0368C222.576 105.221 222.576 111.405 222.576 117.593C222.576 118.249 223.124 118.905 223.792 119.037Z",
    fill: "#8DCFFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.232 167.621C138.232 167.621 136.068 159.893 132.664 157.265C129.264 154.637 126.792 150.929 122.308 149.229C117.828 147.529 116.744 144.433 118.444 143.353C120.144 142.269 125.708 139.177 132.512 146.289C139.312 153.401 141.016 158.965 140.86 165.613C140.704 172.261 138.54 171.489 138.232 167.621Z",
    fill: "#8DCFFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.788 144.977C120.788 144.977 120.812 144.985 120.86 145.001C121.232 145.113 122.956 145.645 124.936 146.413C126.912 147.181 129.156 148.197 130.536 149.233C132.032 150.353 134.212 152.533 136.036 155.193C137.864 157.853 139.328 161.001 139.472 164.037L140.392 163.993C140.228 160.693 138.676 157.425 136.796 154.673C134.908 151.925 132.684 149.697 131.088 148.497C130.276 147.889 129.248 147.321 128.16 146.797C124.896 145.233 121.06 144.101 121.048 144.097L120.788 144.977Z",
    fill: "#7DC2F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.088 170.097C140.088 170.097 143.592 160.201 145.032 157.113C146.476 154.021 146.268 146.597 144.004 143.713C141.736 140.829 138.024 136.501 139.676 130.109C141.324 123.721 140.5 119.805 137.408 122.277C134.316 124.749 128.884 130.205 128.748 138.973C128.648 145.673 130.624 149.593 134.316 154.433C137.304 158.349 140.292 165.561 140.088 170.097Z",
    fill: "#F8C44F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.472 167.781C141.548 167.373 143.324 157.745 141.448 153.685C141.02 152.753 140.448 151.625 139.84 150.433C137.844 146.513 135.112 141.145 134.828 137.405C134.38 131.393 138.144 125.597 138.18 125.537L137.664 125.197C137.504 125.441 133.748 131.233 134.212 137.449C134.504 141.313 137.156 146.525 139.288 150.713C139.892 151.901 140.464 153.025 140.888 153.941C142.68 157.825 140.884 167.569 140.864 167.669L141.472 167.781Z",
    fill: "#FFD917"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.844 155.409C157.864 154.637 158.172 150.001 155.08 149.073C151.988 148.145 146.888 148.301 144.416 151.545C141.548 155.309 140.396 162.057 141.324 166.849C142.252 171.641 141.324 164.997 143.332 161.749C145.344 158.501 150.528 156.049 153.844 155.409Z",
    fill: "#194866"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.788 151.205C155.764 151.201 154.984 151.049 153.796 151.049C152.78 151.049 151.468 151.161 150.08 151.577C148.696 151.993 147.236 152.721 145.956 153.949C142.52 157.249 141.036 161.365 140.412 165.545L141.308 165.681C141.92 161.613 143.332 157.729 146.584 154.601C147.744 153.489 149.064 152.829 150.34 152.445C151.616 152.061 152.848 151.953 153.796 151.953C154.352 151.953 154.812 151.989 155.128 152.025C155.288 152.041 155.412 152.061 155.496 152.073C155.536 152.081 155.568 152.085 155.588 152.089L155.608 152.093H155.612L155.788 151.205Z",
    fill: "#161711"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.44 179.473H144.568L146.424 161.541H131.584L133.44 179.473Z",
    fill: "#2C7EEA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.232 88.7364C162.232 90.1416 161.092 91.2808 159.684 91.2808H30.544C29.14 91.2808 28 90.1416 28 88.7364V66.4708C28 65.0656 29.14 63.9264 30.544 63.9264H159.684C161.092 63.9264 162.232 65.0656 162.232 66.4708V88.7364Z",
    fill: "#F3F3F3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.76 63.9264H30.544C29.14 63.9264 28 65.0656 28 66.4708V88.7364C28 90.1416 29.14 91.2808 30.544 91.2808H56.76V63.9264Z",
    fill: "#FD2227"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1758 72.6057H92.8878V71.3333H64.1758V72.6057Z",
    fill: "#9AC7F7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9839 72.6057H114.2V71.3333H95.9839V72.6057Z",
    fill: "#9AC7F7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7681 83.9616H75.5001V82.6892H71.7681V83.9616Z",
    fill: "#9AC7F7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8838 76.3903H92.3358V75.1179H80.8838V76.3903Z",
    fill: "#9AC7F7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8921 80.1768H92.3361V78.9044H85.8921V80.1768Z",
    fill: "#9AC7F7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3398 83.9616H92.3358V82.6892H78.3398V83.9616Z",
    fill: "#9AC7F7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2002 76.3903H77.8322V75.1179H75.2002V76.3903Z",
    fill: "#9AC7F7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 76.3903H72.5918V75.1179H64.2598V76.3903Z",
    fill: "#9AC7F7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 80.1768H83.3478V78.9044H64.2598V80.1768Z",
    fill: "#9AC7F7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 83.9616H68.7758V82.6892H64.2598V83.9616Z",
    fill: "#9AC7F7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3081 76.3903H109.304V75.1179H95.3081V76.3903Z",
    fill: "#9AC7F7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7598 80.1768L118.02 80.1484L118.016 78.876L99.7598 78.9044",
    fill: "#9AC7F7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8521 83.9616H109.304V82.6892H97.8521V83.9616Z",
    fill: "#9AC7F7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.444 76.3903H118.016V75.1179H112.444V76.3903Z",
    fill: "#9AC7F7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7119 80.1768H97.3399V78.9044H94.7119V80.1768Z",
    fill: "#9AC7F7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2959 83.9616H99.1759V82.6892H95.2959V83.9616Z",
    fill: "#9AC7F7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7239 82.7704H33.8679V81.118L36.6879 78.2652C37.5239 77.4096 38.0679 76.8164 38.3239 76.486C38.5839 76.1552 38.7679 75.8488 38.8799 75.5672C38.9919 75.2852 39.0479 74.9928 39.0479 74.6904C39.0479 74.2396 38.9239 73.9036 38.6759 73.6836C38.4239 73.4628 38.0959 73.3528 37.6799 73.3528C37.2439 73.3528 36.8199 73.4528 36.4119 73.6524C35.9999 73.8524 35.5719 74.1368 35.1279 74.506L33.8359 72.9764C34.3879 72.5048 34.8479 72.1716 35.2119 71.9768C35.5759 71.7816 35.9719 71.632 36.4039 71.5268C36.8319 71.4216 37.3159 71.3688 37.8479 71.3688C38.5519 71.3688 39.1719 71.4972 39.7079 71.7536C40.2479 72.01 40.6639 72.3688 40.9599 72.83C41.2599 73.2916 41.4079 73.8188 41.4079 74.414C41.4079 74.9312 41.3159 75.4168 41.1359 75.8708C40.9519 76.3244 40.6719 76.7888 40.2919 77.266C39.9079 77.7424 39.2359 78.4216 38.2719 79.3028L36.8239 80.664V80.7716H41.7239V82.7704Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3162 82.7704H42.4602V81.118L45.2842 78.2652C46.1162 77.4096 46.6642 76.8164 46.9202 76.486C47.1762 76.1552 47.3602 75.8488 47.4722 75.5672C47.5842 75.2852 47.6402 74.9928 47.6402 74.6904C47.6402 74.2396 47.5162 73.9036 47.2682 73.6836C47.0202 73.4628 46.6882 73.3528 46.2722 73.3528C45.8362 73.3528 45.4162 73.4528 45.0042 73.6524C44.5962 73.8524 44.1682 74.1368 43.7202 74.506L42.4282 72.9764C42.9842 72.5048 43.4402 72.1716 43.8042 71.9768C44.1682 71.7816 44.5682 71.632 44.9962 71.5268C45.4282 71.4216 45.9082 71.3688 46.4442 71.3688C47.1442 71.3688 47.7642 71.4972 48.3042 71.7536C48.8402 72.01 49.2602 72.3688 49.5562 72.83C49.8522 73.2916 50.0002 73.8188 50.0002 74.414C50.0002 74.9312 49.9122 75.4168 49.7282 75.8708C49.5482 76.3244 49.2642 76.7888 48.8842 77.266C48.5002 77.7424 47.8282 78.4216 46.8642 79.3028L45.4202 80.664V80.7716H50.3162V82.7704Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.156 82.0005C148.768 80.2933 146.344 76.9717 146.344 75.3593C146.344 73.2569 148.052 71.5461 150.156 71.5461C152.256 71.5461 153.968 73.2569 153.968 75.3593C153.968 76.9701 151.544 80.2925 150.156 82.0005ZM150.156 70.2737C147.352 70.2737 145.072 72.5549 145.072 75.3593C145.072 77.9777 149.2 82.8601 149.672 83.4089L150.156 83.9701L150.636 83.4089C151.108 82.8601 155.24 77.9777 155.24 75.3593C155.24 72.5549 152.96 70.2737 150.156 70.2737Z",
    fill: "#9AC7F7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.144 76.6129C149.444 76.6129 148.872 76.0425 148.872 75.3405C148.872 74.6385 149.444 74.0685 150.144 74.0685C150.844 74.0685 151.416 74.6385 151.416 75.3405C151.416 76.0425 150.844 76.6129 150.144 76.6129ZM150.144 72.7957C148.74 72.7957 147.6 73.9369 147.6 75.3405C147.6 76.7433 148.74 77.8853 150.144 77.8853C151.548 77.8853 152.688 76.7433 152.688 75.3405C152.688 73.9369 151.548 72.7957 150.144 72.7957Z",
    fill: "#9AC7F7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.252 71.3904C137.412 71.3904 139.984 73.9612 139.984 77.1224C139.984 80.282 137.412 82.8536 134.252 82.8536C131.092 82.8536 128.52 80.282 128.52 77.1224C128.52 73.9612 131.092 71.3904 134.252 71.3904ZM134.252 84.126C138.112 84.126 141.256 80.984 141.256 77.1224C141.256 73.26 138.112 70.1184 134.252 70.1184C130.388 70.1184 127.248 73.26 127.248 77.1224C127.248 80.984 130.388 84.126 134.252 84.126Z",
    fill: "#9AC7F7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.244 79.2156L134.884 76.8576V72.668H133.612V77.3844L136.344 80.116L137.244 79.2156Z",
    fill: "#9AC7F7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.232 55.81C162.232 57.2152 161.092 58.3548 159.684 58.3548H30.544C29.14 58.3548 28 57.2152 28 55.81V33.5444C28 32.1392 29.14 31 30.544 31H159.684C161.092 31 162.232 32.1392 162.232 33.5444V55.81Z",
    fill: "#F3F3F3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.76 31H30.544C29.14 31 28 32.1392 28 33.5444V55.81C28 57.2152 29.14 58.3548 30.544 58.3548H56.76V31Z",
    fill: "#9AC7F7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1758 39.6792H92.8878V38.4072H64.1758V39.6792Z",
    fill: "#9AC7F7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9839 39.6792H114.2V38.4072H95.9839V39.6792Z",
    fill: "#9AC7F7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7681 51.0352H75.5001V49.7628H71.7681V51.0352Z",
    fill: "#9AC7F7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8838 43.4641H92.3358V42.1917H80.8838V43.4641Z",
    fill: "#9AC7F7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8921 47.2504H92.3361V45.978H85.8921V47.2504Z",
    fill: "#9AC7F7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3398 51.0352H92.3358V49.7628H78.3398V51.0352Z",
    fill: "#9AC7F7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2002 43.4641H77.8322V42.1917H75.2002V43.4641Z",
    fill: "#9AC7F7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 43.4641H72.5918V42.1917H64.2598V43.4641Z",
    fill: "#9AC7F7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 47.2504H83.3478V45.978H64.2598V47.2504Z",
    fill: "#9AC7F7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2598 51.0352H68.7758V49.7628H64.2598V51.0352Z",
    fill: "#9AC7F7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3081 43.4641H109.304V42.1917H95.3081V43.4641Z",
    fill: "#9AC7F7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7598 47.2504L118.02 47.222L118.016 45.9496L99.7598 45.978",
    fill: "#9AC7F7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8521 51.0352H109.304V49.7628H97.8521V51.0352Z",
    fill: "#9AC7F7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.444 43.4641H118.016V42.1917H112.444V43.4641Z",
    fill: "#9AC7F7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7119 47.2504H97.3399V45.978H94.7119V47.2504Z",
    fill: "#9AC7F7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2959 51.0352H99.1759V49.7628H95.2959V51.0352Z",
    fill: "#9AC7F7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7401 49.8444H37.3641V43.3408L37.3881 42.2716L37.4241 41.1032C37.0321 41.498 36.7561 41.7572 36.6041 41.88L35.3121 42.9176L34.1641 41.488L37.7881 38.6044H39.7401V49.8444Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3198 40.1964C45.9118 40.1964 45.5878 40.3 45.3398 40.5076C45.0918 40.7152 44.9678 40.9932 44.9678 41.3416C44.9678 41.6496 45.0638 41.9244 45.2638 42.1684C45.4598 42.4112 45.8158 42.6616 46.3358 42.9176C46.8358 42.6816 47.1878 42.4408 47.3878 42.1948C47.5878 41.9492 47.6878 41.6648 47.6878 41.3416C47.6878 40.9876 47.5598 40.7088 47.3038 40.5036C47.0478 40.2988 46.7198 40.1964 46.3198 40.1964ZM44.5838 46.8536C44.5838 47.2944 44.7358 47.6384 45.0438 47.884C45.3518 48.1296 45.7718 48.2532 46.3038 48.2532C46.8918 48.2532 47.3358 48.1268 47.6238 47.8728C47.9198 47.6188 48.0638 47.2848 48.0638 46.8688C48.0638 46.526 47.9198 46.204 47.6278 45.9044C47.3398 45.6044 46.8718 45.2852 46.2198 44.9476C45.1278 45.4496 44.5838 46.0852 44.5838 46.8536ZM46.3358 38.4584C47.4118 38.4584 48.2798 38.7036 48.9358 39.1928C49.5958 39.6824 49.9238 40.342 49.9238 41.1728C49.9238 41.746 49.7678 42.258 49.4478 42.7064C49.1318 43.1544 48.6198 43.556 47.9118 43.91C48.7518 44.3604 49.3558 44.8304 49.7198 45.32C50.0878 45.8096 50.2718 46.3464 50.2718 46.9308C50.2718 47.8532 49.9078 48.5952 49.1878 49.1568C48.4638 49.7176 47.5118 49.998 46.3358 49.998C45.1038 49.998 44.1398 49.7372 43.4358 49.2144C42.7318 48.6916 42.3838 47.9512 42.3838 46.992C42.3838 46.3516 42.5518 45.7828 42.8958 45.2852C43.2358 44.7884 43.7838 44.3504 44.5358 43.9712C43.8958 43.566 43.4318 43.1332 43.1518 42.6716C42.8718 42.2104 42.7278 41.7056 42.7278 41.1572C42.7278 40.3528 43.0638 39.7016 43.7278 39.2044C44.3958 38.7076 45.2638 38.4584 46.3358 38.4584Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.156 49.0741C148.768 47.3669 146.344 44.0457 146.344 42.4329C146.344 40.3305 148.052 38.6197 150.156 38.6197C152.256 38.6197 153.968 40.3305 153.968 42.4329C153.968 44.0437 151.544 47.3661 150.156 49.0741ZM150.156 37.3473C147.352 37.3473 145.072 39.6285 145.072 42.4329C145.072 45.0513 149.2 49.9337 149.672 50.4825L150.156 51.0441L150.636 50.4825C151.108 49.9337 155.24 45.0513 155.24 42.4329C155.24 39.6285 152.96 37.3473 150.156 37.3473Z",
    fill: "#9AC7F7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.144 43.6865C149.444 43.6865 148.872 43.1161 148.872 42.4141C148.872 41.7121 149.444 41.1421 150.144 41.1421C150.844 41.1421 151.416 41.7121 151.416 42.4141C151.416 43.1161 150.844 43.6865 150.144 43.6865ZM150.144 39.8693C148.74 39.8693 147.6 41.0109 147.6 42.4141C147.6 43.8169 148.74 44.9589 150.144 44.9589C151.548 44.9589 152.688 43.8169 152.688 42.4141C152.688 41.0109 151.548 39.8693 150.144 39.8693Z",
    fill: "#9AC7F7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.252 38.464C137.412 38.464 139.984 41.0352 139.984 44.196C139.984 47.3556 137.412 49.9276 134.252 49.9276C131.092 49.9276 128.52 47.3556 128.52 44.196C128.52 41.0352 131.092 38.464 134.252 38.464ZM134.252 51.2C138.112 51.2 141.256 48.0576 141.256 44.196C141.256 40.3336 138.112 37.192 134.252 37.192C130.388 37.192 127.248 40.3336 127.248 44.196C127.248 48.0576 130.388 51.2 134.252 51.2Z",
    fill: "#9AC7F7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.244 46.2892L134.884 43.9312V39.7416H133.612V44.458L136.344 47.1896L137.244 46.2892Z",
    fill: "#9AC7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyLog);
export default __webpack_public_path__ + "static/media/study_log.68acb3f76d928dc7145568243cb2a97b.svg";
export { ForwardRef as ReactComponent };